// import config from '../config';
import config from '../assets/config';
import { ax } from './base';

export default class ItemsService {
   
    GetItemsSearchData(payload){
        return ax.post(`${config.apiUrl}Items/GetItemsSearchData`,payload)
    }
    // SaveMasCOA(payload){
    //     return ax.post(`${config.apiUrl}COA/SaveMasCOA`,payload)
    // }
    
    SaveItems(payload){
        return ax.post(`${config.apiUrl}Items/SaveItems`,payload)
    }
    
    GetItemsTenant(ID,TenantID,Status,Type){
        return ax.get(`${config.apiUrl}Items/GetItemsTenant/${ID}/${TenantID}/${Status}/${Type}`);
    }    
    
    //asset management
    GetAssetManagementSearchData(payload){
        return ax.post(`${config.apiUrl}Items/GetAssetManagementSearchData`,payload)
    }
    SaveAsset(payload){
        return ax.post(`${config.apiUrl}Items/SaveAsset`,payload)
    }
    GenerateConfigNumber(payload){
        return ax.post(`${config.apiUrl}Common/GenerateConfigNumber`,payload)
    }   
    GetAssetTypeLists(TenantID){
        return ax.get(`${config.apiUrl}Items/GetAssetTypeLists/${TenantID}`);
    }    
    deleteasset(TenantID,Asset){
        return ax.delete(`${config.apiUrl}Items/deleteasset/${TenantID}/${Asset}`);
    }  
    
    GetMasCountryList(){
        return ax.get(`${config.apiUrl}Common/GetMasCountryList`);
    }  
    GetMasCountryStateList(CountryId){
        return ax.get(`${config.apiUrl}Common/GetMasCountryStateList/${CountryId} `);
    }  
    GetMasTaxCode(payload){
        return ax.post(`${config.apiUrl}Purchase/GetMasTaxCode`,payload)
    }
}
